
import { Fragment } from "react"
import {
  isAIScanMeal,
  isAIScanNutritionFactsMeal,
  isAIScanPackageMeal,
  isEdamaMeal,
  isMyMeal,
  isOpenFoodFactMeal,
} from "model/food/utils/typeGuards/mealTypeGuards"
import { MealType } from "model/food/types"
import EdamaNameAndPortion from "components/foodDetails/share/EdamaNameAndPortion"
import MyFoodNameAndPortion from "components/foodDetails/share/MyFoodNameAndPortion"
import OpenFoodFactNameAndPortion from "components/foodDetails/share/OpenFoodFactNameAndPortion"
import AIScanNameAndPortion from "components/foodDetails/share/AIScanNameAndPortion"

interface IUpdateMealNameAndPortionProps {
  meal: MealType
  disabled: boolean
  handlePortionChange: (value: number) => void
  onUnitChange: (unit: string) => void
  setIsPortionValid: (isValid: boolean) => void
  gram: null | number
  isFutureScheduleMeal: boolean
}

const UpdateMealNameAndPortion = (props: IUpdateMealNameAndPortionProps) => {
  const {
    meal,
    handlePortionChange,
    onUnitChange,
    disabled,
    setIsPortionValid,
    gram,
    isFutureScheduleMeal,
  } = props
  return (
    <Fragment>
      {isMyMeal(meal) && (
        <MyFoodNameAndPortion
          food={meal}
          portionValue={meal.portion}
          unitValue={meal.unit}
          onPortionChange={handlePortionChange}
          onUnitChange={onUnitChange}
          disabled={disabled}
          setIsPortionValid={setIsPortionValid}
          calories={meal.calorie}
          gram={gram}
          isFutureScheduleMeal={isFutureScheduleMeal}
        />
      )}

      {(isAIScanMeal(meal) ||
        isAIScanPackageMeal(meal) ||
        isAIScanNutritionFactsMeal(meal)) && (
        <AIScanNameAndPortion
          food={meal}
          portionValue={meal.portion}
          unitValue={meal.unit}
          onPortionChange={handlePortionChange}
          onUnitChange={onUnitChange}
          disabled={disabled}
          setIsPortionValid={setIsPortionValid}
          calories={meal.calorie}
          gram={gram}
          isFutureScheduleMeal={isFutureScheduleMeal}
        />
      )}

      {isEdamaMeal(meal) && (
        <EdamaNameAndPortion
          edama={meal}
          portionValue={meal.portion}
          unitValue={meal.unit}
          onPortionChange={handlePortionChange}
          onUnitChange={onUnitChange}
          disabled={disabled}
          setIsPortionValid={setIsPortionValid}
          calories={meal.calorie}
          gram={gram}
          unitOptions={meal.units}
          isFutureScheduleMeal={isFutureScheduleMeal}
        />
      )}

      {isOpenFoodFactMeal(meal) && (
        <OpenFoodFactNameAndPortion
          food={meal}
          portionValue={meal.portion}
          unitValue={meal.unit}
          onPortionChange={handlePortionChange}
          disabled={disabled}
          setIsPortionValid={setIsPortionValid}
          calories={meal.calorie}
          gram={gram}
          isFutureScheduleMeal={isFutureScheduleMeal}
        />
      )}
    </Fragment>
  )
}

export default UpdateMealNameAndPortion
